import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";

export class Role extends BaseModel {
	id: string
	name: string
	alias: string
	permissions: string
	documentPermissions: string
}

export interface DepartmentRole {
	departmentId: string
	roleId: string
}


export class RoleDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
}
